import React, { useEffect, useState } from 'react';
import { assetUrl } from '../utils/assetUrl';
import { isMobileDevice } from '../utils/isMobileDevice';
import profilePic from '../images/profile3.png';
import './SplashScreen.css';

const preloadImage = (src) =>
  new Promise((resolve) => {
    const img = new Image();
    img.onload = resolve;
    img.onerror = resolve;
    img.src = src;
  });

const getCriticalAssets = () => {
  const assets = [
    `${process.env.PUBLIC_URL}/logo.jpg`,
    assetUrl('cover-images/answers2god.png'),
    assetUrl('cover-images/pendora.png'),
    assetUrl('cover-images/Al-Qaswa.png'),
    assetUrl('cover-images/design-genie.png'),
  ];

  if (!isMobileDevice()) {
    assets.push(profilePic);
  }

  return assets;
};

const SplashScreen = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    let mounted = true;
    const assets = getCriticalAssets();
    let loaded = 0;

    const updateProgress = () => {
      loaded += 1;
      if (mounted) {
        setProgress(Math.round((loaded / assets.length) * 100));
      }
    };

    const assetPromises = assets.map((src) => preloadImage(src).then(updateProgress));
    const minDisplay = new Promise((resolve) => setTimeout(resolve, 1400));

    Promise.all([Promise.all(assetPromises), minDisplay]).then(() => {
      if (!mounted) return;
      setProgress(100);
      setIsExiting(true);
      setTimeout(() => {
        if (mounted) onComplete();
      }, 550);
    });

    return () => {
      mounted = false;
    };
  }, [onComplete]);

  return (
    <div className={`splash-screen ${isExiting ? 'splash-screen--exit' : ''}`} aria-hidden={isExiting}>
      <div className="splash-screen__bg" />
      <div className="splash-screen__orb splash-screen__orb--1" />
      <div className="splash-screen__orb splash-screen__orb--2" />

      <div className="splash-screen__content">
        <div className="splash-screen__logo-wrap">
          <img
            src={`${process.env.PUBLIC_URL}/logo.jpg`}
            alt=""
            className="splash-screen__logo"
          />
        </div>
        <h1 className="splash-screen__title">
          Junaid <span>Nasir</span>
        </h1>
        <p className="splash-screen__subtitle">Flutter Expert & Web Developer</p>

        <div className="splash-screen__progress-track">
          <div
            className="splash-screen__progress-bar"
            style={{ width: `${progress}%` }}
          />
        </div>
        <p className="splash-screen__progress-label">{progress}%</p>
      </div>
    </div>
  );
};

export default SplashScreen;
